import { useNavigate } from "react-router-dom"
import { Lock } from "lucide-react"
import { AppHeader } from "@/components/dashboard/AppHeader"
import { Button } from "@/components/ui/button"
import { useDashboardGuard } from "@/lib/activation"

export function CapitalPipelineScreen() {
  const guard = useDashboardGuard()
  const navigate = useNavigate()

  if (guard) return guard

  return (
    <main className="min-h-screen bg-background text-foreground">
      <AppHeader active="capital-pipeline" status="online" showNav />
      <section className="mx-auto flex w-full max-w-[1600px] items-center justify-center p-4 md:p-6 lg:p-8">
        <div className="flex w-full max-w-2xl flex-col items-center rounded-2xl border border-border bg-card p-12 text-center shadow-sm">
          <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-border bg-muted shadow-sm">
            <Lock className="h-8 w-8 text-muted-foreground" />
          </div>
          <h1 className="mb-3 text-2xl font-bold text-foreground">Capital Pipeline</h1>
          <p className="max-w-md text-base leading-relaxed text-muted-foreground">
            Pipeline locked — complete Early Stage Momentum to unlock capital and begin building JV partnerships
          </p>
          <Button type="button" variant="secondary" size="sm" onClick={() => navigate("/dashboard")} className="mt-8">
            Back to Dashboard
          </Button>
        </div>
      </section>
    </main>
  )
}
